export default function prepareFormValues(formValues) {
  const values = {} as Record<string, any>;
  Object.keys(formValues).forEach((key) => {
    // convert score to string
    if (
      formValues[key] &&
      Object.prototype.hasOwnProperty.call(formValues[key], 'score')
    ) {
      values[key] = {
        ...formValues[key],
        score: formValues[key].score.toString(),
      };
    } else {
      values[key] = formValues[key];
    }
  });
  return values;
}
